import { useRef, useEffect } from 'react';

const useAutoScroll = (conversationLength, isActivelyStreaming, streamingAIResponse, showWelcome) => {
    const chatWrapperRef = useRef(null);
    const messagesEndRef = useRef(null);
    const shouldScrollOnNextMessageRef = useRef(false);
    // Scroll to bottom function with improved behavior
    const scrollToBottom = () => {
        setTimeout(() => {
            const wrapper = chatWrapperRef.current;
            if (!wrapper)
                return;
            const targetTop = wrapper.scrollHeight - wrapper.clientHeight;
            wrapper.scrollTo({ top: targetTop, behavior: "smooth" });
        }, 300);
    };
    // Auto-scroll when user sends a new message
    useEffect(() => {
        if (shouldScrollOnNextMessageRef.current &&
            conversationLength > 0 &&
            !showWelcome) {
            scrollToBottom();
            shouldScrollOnNextMessageRef.current = false;
        }
    }, [conversationLength, showWelcome]);
    // Auto-scroll when streaming begins
    useEffect(() => {
        if (isActivelyStreaming && conversationLength > 0 && !showWelcome) {
            scrollToBottom();
        }
    }, [isActivelyStreaming, streamingAIResponse, conversationLength, showWelcome]);
    return {
        chatWrapperRef,
        messagesEndRef,
        shouldScrollOnNextMessageRef,
        scrollToBottom,
    };
};

export { useAutoScroll };
//# sourceMappingURL=useAutoScroll.js.map
